module.exports = __webpack_public_path__ + "static/jimmy-kimmel-5d9f9c9b9fb99d9cfd9fbc8d3c90c021.jpg";